import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonFab, IonFabButton, IonIcon } from '@ionic/react';
import React from 'react';
import ExploreContainer from '../components/ExploreContainer';
import { add, logoApple, logoAndroid, chatboxEllipsesOutline } from 'ionicons/icons';
import './Home.css';
import { RouteChildrenProps } from 'react-router';
import InstallButton from '../components/InstallPWAButton';

const Contact: React.FC<RouteChildrenProps> = (props) => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle></IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large"></IonTitle>
                    </IonToolbar>
                </IonHeader>
                <div style={{ textAlign: 'center', position: 'absolute', left: 0, right: 0, top: '50%', transform: 'translateY(-50%)' }}>
                    <strong>Please write to us on: tashi.wck@gmail.com</strong>
                    <p></p>
                </div>
                <IonFab vertical="bottom" horizontal="start" slot="fixed">
                    <IonFabButton onClick={() => props.history.push('/notice')}>
                        <InstallButton /> 
                    </IonFabButton>
                </IonFab>
                <IonFab vertical="bottom" horizontal="end" slot="fixed">
                    <IonFabButton onClick={() => props.history.push('/contact')} title="Contact Us">
                        <IonIcon icon={chatboxEllipsesOutline} />
                    </IonFabButton>
                </IonFab>
            </IonContent>
        </IonPage>
    );
};

export default Contact;
